import { Location } from "history";
import * as React from "react";
import { QueryClient } from "react-query";
import { connect, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Action, Dispatch } from "redux";
import { useFeaturesQuery } from "store/selectors/hooks";
import { baseAppDataLoaded } from "store/selectors/selectors";
import { useTenantSettings } from "store/selectors/settings";
import { ApplicationState } from "store/state";
import * as actions from "../../store/actions";
import { LoginWorkflowContainer } from "./login-workflow-container";
import { NgContainer } from "./ng-container";

const isLoginWorkflowRoute = (pathname: string): boolean => {
    if (pathname === "/login") return true;
    if (pathname === "/license") return true;
    if (pathname === "/account/reset-password") return true;
    if (pathname === "/account/reset") return true;
    if (pathname === "/two-factor-verification") return true;
    if (pathname.startsWith("/outlook-admin-consent/")) return true;
    return false;
};

interface ContainerPropsFromState {
    children: React.ReactNode;
    location: Location;
}

interface ContainerPropsFromDispatch {
    loadAll: (queryClient: QueryClient) => void;
}

interface ContainerOwnProps {
    queryClient: QueryClient;
}

type ContainerProps = ContainerPropsFromDispatch &
    ContainerPropsFromState &
    ContainerOwnProps;

class Container extends React.Component<ContainerProps, undefined> {
    UNSAFE_componentWillMount() {
        if (!isLoginWorkflowRoute(this.props.location.pathname)) {
            this.props.loadAll(this.props.queryClient);
        }
    }

    render() {
        return <ContainerInner {...this.props} />;
    }
}

const ContainerInner: React.FC<ContainerProps> = props => {
    const {
        location: { pathname },
        children,
    } = props;

    const { status } = useTenantSettings();
    const baseReduxStateLoaded = useSelector((state: ApplicationState) =>
        baseAppDataLoaded(state),
    );
    const features = useFeaturesQuery();
    const appDataLoaded =
        status === "success" && baseReduxStateLoaded && !features.isLoading;

    if (!isLoginWorkflowRoute(pathname) && !appDataLoaded) {
        return null;
    }

    if (isLoginWorkflowRoute(pathname)) {
        return <LoginWorkflowContainer>{children}</LoginWorkflowContainer>;
    }

    return <NgContainer>{children}</NgContainer>;
};

function mapDispatchToProps(dispatch: Dispatch<Action>): ContainerPropsFromDispatch {
    return {
        loadAll: (queryClient: QueryClient) => {
            actions.loadAll(queryClient, dispatch);
        },
    };
}

function mapStateToProps(
    state: ApplicationState,
    ownProps: RouteComponentProps & { children: React.ReactNode },
): ContainerPropsFromState {
    return {
        children: ownProps.children,
        location: ownProps.location,
    };
}

const component = withRouter(connect(mapStateToProps, mapDispatchToProps)(Container));
export { component as Container };
